export default {
  connections: {
    sharing: 'web sharing',
    settings: 'web account settings',
  },
};
